import { render, staticRenderFns } from "./ModalRateioContabil.vue?vue&type=template&id=3b7d4422"
import script from "./ModalRateioContabil.vue?vue&type=script&lang=js"
export * from "./ModalRateioContabil.vue?vue&type=script&lang=js"
import style0 from "./ModalRateioContabil.vue?vue&type=style&index=0&id=3b7d4422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports